import { GCM_SIGNUP_FAILS } from '../../../components/gcm/Constants'
import { getLeadSource } from '../../../utils/analytics/leadSourceHelper'
import redirector from '../../../utils/redirector'
import { triggerSignup } from '../../auth/actions/signupUtils'
import getTourPackageRequestObject from '../getTourPackageRequestObject'
import createMaldivesItinerary from './createMaldivesItinerary'

/**
 * Used to trigger the get cost action
 * @param {*} itineraryInfo
 * @param {*} user_details
 * @param {*} history
 * @param {*} lastLocation
 * @param {*} match
 * @param {*} configObj
 * @param {*} actions
 */
function triggerTourPackageViewDeal({
	lastLocation = {},
	passengerDetail = {},
	router,
	appDispatch,
	gcmDispatch,
	userDetails,
	locale,
	costingConfig,
}) {
	const leadSourceData = getLeadSource({
		router,
		lastLocation,
		version: 'SPEEDBOAT',
	})

	const isUserExist = userDetails && userDetails.loggedIn

	const proceedToMleCreateItinerary = () => {
		const requestData = {
			resortCode: router?.query?.resortCode,
			...{
				...getTourPackageRequestObject({ query: router?.query }),
				...costingConfig,
			},
		}

		createMaldivesItinerary(
			requestData,
			itineraryId => {
				// redirector(
				// 	`${
				// 		locale ? `/${locale}` : ''
				// 	}/customize/mle/inclusions/${itineraryId}`,
				// )
				redirector(
					`${
						locale ? `/${locale}` : ''
					}/customize/mle/inclusions/calculating-cost/${itineraryId}`,
				)
			},
			() => {},
			router,
			{},
			locale,
		)
	}

	if (isUserExist) {
		proceedToMleCreateItinerary()
	} else {
		const { name, email, mobileNumber, countryPhoneCode } =
			passengerDetail || {}
		let reqObj = {
			countryPhoneCode,
			mobileNumber,
			userName: name,
			email,
			cpid: sessionStorage && sessionStorage.getItem('campaignId'),
			leadSource: leadSourceData,
			canSendWhatsAppMessages: true,
		}

		triggerSignup({
			reqObj,
			signupType: 'SIGNUP',
			leadSource: reqObj.leadSource,
			successSubmitCallback: () => {
				proceedToMleCreateItinerary()
			},
			dispatch: appDispatch,
			failureSubmitCallback: error => {
				if (
					error.status === 'MOBILE_EXISTS' ||
					error.status === 'EMAIL_EXISTS'
				) {
					const noteMessage =
						error.message ||
						'This mobile number is already registered with a different email ID to which the vouchers will be shared to. Please check the account details section after logging in.'

					let defaultState = {
						status: error.status,
						noteMessage,
						alreadyExist: true,
					}

					if (error.status === 'MOBILE_EXISTS') {
						defaultState = {
							...defaultState,
							defaulMobileNumber: `${mobileNumber}`,
							defaultCountryPhoneCode: countryPhoneCode,
						}
					} else {
						defaultState = {
							...defaultState,
							defaultEmail: email,
						}
					}

					gcmDispatch &&
						gcmDispatch({
							type: GCM_SIGNUP_FAILS,
							payload: {
								...defaultState,
							},
						})
					// triggerLoginAction({
					//   itineraryId,
					//   history,
					//   regionCode,
					//   campaign: true,
					//   costingConfig: {
					//     ...costingConfig,
					//     name: title,
					//     itineraryId,
					//     costingType: 'RECOST',
					//     flightsBookedByUserAlready
					//   },
					//   isFlightBookedByUser: flightsBookedByUserAlready,
					//   preState: {
					//     ...defaultState
					//   }
					// })
				} else {
					// onSignUpFail({
					//   match,
					//   passengerDetail,
					//   dealDetails,
					//   itineraryId,
					//   history,
					//   screenName: 'signup',
					//   emailAlreadyExist:
					//     typeof error.email === 'string' ? error.email : ''
					// });
				}
			},
		}).catch(() => {})
	}
}

export default triggerTourPackageViewDeal
